import React, { useEffect, useState } from 'react'
import $ from 'jquery'

export default function Daily_update() {
    const [updatesList, setUpdatesList] = useState([]);
    const active_pro_name = localStorage.getItem('selected_project_name');
    const [alertMsg, setAlertMsg] = useState('');
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [membretype, setMembertype] = useState(false);

    useEffect(()=>{
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
    })

    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg('');
    };

    function openPreviousUpdates() {

        const memberid = localStorage.getItem('member_id');

        const formData = new FormData();
        formData.append("memberid", memberid);

        fetch('getMemberUpdate.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(result => {
                console.log(result);

                if (result.status === "success") {
                    setUpdatesList(result.data); // ✅ STORE DATA
                    document.getElementById('listupdate').style.display = "block";
                } else {
                    alert(result.message);
                }
            })
            .catch(err => {
                console.error(err);
            });
    }
    function closePreviousUpdates() {
        document.getElementById('listupdate').style.display = "none";
    }

    const saveUpdates = () => {
        const active_pro_id = localStorage.getItem('selected_project_id');
        const active_pro_name = localStorage.getItem('selected_project_name');
        const membername = localStorage.getItem('membername');
        const memberid = localStorage.getItem('member_id');
        const com_id = localStorage.getItem('mem_company_id');
        const description = document.getElementById('dailyupdate').value;
        document.getElementById('updateloader').style.display = "block";

        const formData = new FormData();
        formData.append("membername", membername);
        formData.append("description", description);
        formData.append("pro_id", active_pro_id);
        formData.append("pro_name", active_pro_name);
        formData.append("memberid", memberid);
        formData.append("com_id", com_id);

        fetch('saveUpdate.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(result => {
                console.log(result);

                if (result.status === "success") {
                    showAlert("Update submited successfully");
                    document.getElementById('updateloader').style.display = "none";
                    document.getElementById('dailyupdate').value = '';
                    // refresh list

                } else {
                    alert(result.message);
                }
            })
            .catch(err => {
                console.error(err);
            });

    }
    return (
        <div>
            <div className='topbar_menu'>
                <button className='member_button  addmembtn' onClick={openPreviousUpdates}>View Previous Updates</button>
                <p>Update for {active_pro_name}</p>
            </div>
            <div className='member_row'>
                <div className='member_details'>
                    <section className='vl_dsh_bodypart_section pos_rel'>
                        <div className='vl_listing_area'>
                            <h3 className='details_heading'>Insert your update</h3>
                            <p className='notetext'>Here you have to give the summery of the work you have done today. Remember, client can see this update in his report page.</p>
                            <div className='vl_dsh_formnholder'>
                                <div className='formfieldcommon'>
                                    <textarea id="dailyupdate" placeholder='Insert your update'></textarea>
                                </div>
                                <div className='formfieldcommon'>
                                    <button onClick={saveUpdates}>Submit</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div className='camp_log_pop' id="listupdate">
                <div className='camp_log_container'>

                    <div className='closebtnholder'>
                        <button className='closeBtn' onClick={closePreviousUpdates}>+</button>
                    </div>

                    {updatesList.length === 0 ? (
                        <p className='mt-30'>No updates found</p>
                    ) : (
                        updatesList.map((item, index) => (
                            <div className='fullwidth pull_left mt-30' key={index}>
                                <div className='sendersspan'>
                                    <h4 className='pull_left'>
                                        {item.username}
                                        <span> {item.created_date} </span>
                                    </h4>
                                    <p className='mt-15'>{item.report_text}</p>
                                </div>
                            </div>
                        ))
                    )}

                </div>
            </div>

            {showAlertBox && (
                <div className='vl_dsh_popup'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>

                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}
            <div className='loaderpop' id="updateloader">
                <p className='loadertext'>Please wait...</p>
            </div>

             {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
